import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "./layouts/navbar";
import PageRouter from "./pages/routes/Router";
import Sidebar from "./layouts/sidebar/sidebar";
import "./assets/css/App.css";
import { useEffect } from "react";



function App() {
  const userDataFromSession = JSON.parse(localStorage.getItem("userData"));
  const [userData, setUserData] = useState(userDataFromSession);
  const cheifNoFromSession = JSON.parse(localStorage.getItem("chiefNo"));
  const [chiefNo, setChiefNo] = useState(cheifNoFromSession);


  useEffect(() => {
    if(chiefNo == null && userData == null){
      localStorage.removeItem('userData');
      localStorage.removeItem('chiefNo');
      localStorage.removeItem('subNoData');  
      setChiefNo(null);
      setUserData(null)
    }else{
    setChiefNo(cheifNoFromSession);
  }
  }, [chiefNo,userData]);
  return (
   
    <Router>
      {chiefNo && <Navbar userData={userData} setUserData={setUserData} />}
      <div className="app-layout">
        <div className="app-sidebar">
         {chiefNo && <Sidebar userData={userData} setUserData={setUserData} />}
        </div>
        <div className="app-body" style={chiefNo ? { paddingTop: "85px" } : {}}>
          <PageRouter chiefNo={chiefNo} setChiefNo={setChiefNo} />
        </div>
      </div>
    </Router>
  );
}

export default App;
